import React, { Component, useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';

import {
    CollectionsBucket,
    collectionInfoLookup,
} from '../../../../components/FeaturedCollections';

import {
    clickOnOnlineCollection,
    clickOnTransitionOnlineCollection,
    fetchCollectionsForPlace as fetchCollectionsForPlaceAction,
} from '../../redux/content';

import './CollectionsBucketContainer.scss';

const CollectionsBucketContainer = (props) => {
    const {
        currentPlace,
        isFeLoading,
        collections,
        trackGAEvent,
        tabKey,
        trackGAEventOnPageUnload,
        fetchCollectionsForPlace,
        tld,
    } = props;

    useEffect(() => {
        fetchCollectionsForPlace(tabKey);
    }, [tabKey, fetchCollectionsForPlace]);

    let bucketContent = null;

    if (!isFeLoading && !isEmpty(collections) && currentPlace.placeId) {
        const bucketsContent = Object.values(collections);
        let content = collectionInfoLookup({ bucketsContent });

        // The creator avatar is not existent in the API response so we use
        // the eventbrite logo for now
        content = content.map((collection) => ({
            ...collection,
            creatorImageIdOverrideUrl:
                'https://cdn.evbuc.com/images/100912392/438776807040/1/original.20200513-210241',
        }));

        bucketContent = (
            <div className="featured-collections-bucket eds-bg-color--ui-200 eds-l-pad-top-10 eds-l-mar-top-10">
                <CollectionsBucket
                    tld={tld}
                    currentPlace={currentPlace}
                    content={content}
                    trackGAEvent={trackGAEvent}
                    trackGAEventOnPageUnload={trackGAEventOnPageUnload}
                />
            </div>
        );
    }

    return bucketContent;
};

CollectionsBucketContainer.propTypes = {
    currentPlace: PropTypes.string,
    isFeLoading: PropTypes.bool,
    collections: PropTypes.object,
    trackGAEventOnPageUnload: PropTypes.func,
    trackGAEvent: PropTypes.func,
};

const _mapStateToProps = ({ app, content, location }) => ({
    isFeLoading: app.loadingState && app.loadingState.isFeLoading,
    isBotRequest: app.isBotRequest,
    currentPlace: location.currentPlace,
    tld: app.tld,
    collections:
        content.editorialCollections && content.editorialCollections.entities,
});

const _mapDispatchToProps = {
    trackGAEventOnPageUnload: clickOnOnlineCollection,
    trackGAEvent: clickOnTransitionOnlineCollection,
    fetchCollectionsForPlace: fetchCollectionsForPlaceAction,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(CollectionsBucketContainer);
